import { render, staticRenderFns } from "./CMSTemplateForm.vue?vue&type=template&id=d2d60982&"
import script from "./CMSTemplateForm.vue?vue&type=script&lang=js&"
export * from "./CMSTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports